import React, { useState, useEffect } from 'react';
import { heroVideo, companyInfo } from '../data/mock';

const HeroSection = () => {
  const [titleVisible, setTitleVisible] = useState(false);

  useEffect(() => {
    // Preload video instantly
    const video = document.createElement('video');
    video.src = heroVideo.url;
    video.preload = 'auto';
    video.muted = true;
    video.load();
    
    // Trigger title animation after component mounts
    const timer = setTimeout(() => {
      setTitleVisible(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-full h-full object-cover opacity-60"
        >
          <source src={heroVideo.url} type="video/mp4" />
        </video>
        {/* Overlay gradient - subtle dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/40" />
      </div>

      {/* Hero Content - Bottom Right Aligned */}
      <div className="relative z-10 h-full flex flex-col justify-end items-end px-4 sm:px-6 md:px-8 lg:px-12 xl:px-24 pb-12 md:pb-16 lg:pb-24">
        <div className="text-right">
          {/* Sub Title */}
          <div
            className={`overflow-hidden mb-2 transition-all duration-1000 ${
              titleVisible
                ? 'translate-y-0 opacity-100'
                : 'translate-y-8 opacity-0'
            }`}
          >
            <p className="text-white/80 text-xs md:text-sm tracking-[0.3em] uppercase">
              {companyInfo.tagline}
            </p>
          </div>
          
          {/* Main Title - IMMERSIVE */}
          <h1 className="overflow-hidden">
            <span
              className={`block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-spectral tracking-[0.05em] text-white transition-all duration-1000 delay-200 leading-none ${
                titleVisible
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-full opacity-0'
              }`}
              style={{ fontFamily: "'Spectral SC', serif" }}
            >
              {companyInfo.heroTitle[0]}
            </span>
          </h1>
          
          {/* Main Title - FILMS */}
          <h1 className="overflow-hidden -mt-2 md:-mt-4">
            <span
              className={`block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-spectral tracking-[0.05em] text-white transition-all duration-1000 delay-400 leading-none ${
                titleVisible
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-full opacity-0'
              }`}
              style={{ fontFamily: "'Spectral SC', serif" }}
            >
              {companyInfo.heroTitle[1]}
            </span>
          </h1>
        </div>
      </div>

      {/* Scroll indicator - bottom center */}
      <div
        className={`absolute bottom-8 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-1000 ${
          titleVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          <div className="w-[1px] h-12 bg-gradient-to-b from-white/0 via-white/60 to-white/0 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
